var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('router-link',{class:_vm.classes,attrs:{"to":_vm.destination}},[_vm._v(_vm._s(_vm.label)+" "),(_vm.count !== undefined)?_c('span',[_vm._v("("+_vm._s(_vm.count)+")")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }